import {
  PERFORM_REQUEST,
  PERFORM_REQUEST_FAILURE,
  PERFORM_REQUEST_SUCCESS,
  SET_PAGE,
  INIT_CATEGORIES,
  INIT_TRANSLATIONS,
  SET_CATEGORY,
  FIND_AND_SET_CATEGORY,
  INIT_LANGUAGE,
  PROJECT_CLEAR_RESULTS,
  PROJECT_SET_SELECTED_TAG,
  INIT_PAST,

  ADD_CATEGORY_FILTER,
  INIT_THEME_CATEGORIES,
  REMOVE_CATEGORY_FILTER,
  PROJECT_SET_SELECTED_THEME_TAG,
  PROJECT_REMOVE_SELECTED_THEME_TAG,
  REMOVE_MANY_FILTERS,
  SET_THEME_CATEGORY,
  PROJECT_FIND_AND_SET_SELECTED_TAG
} from './actions.mjs';

const initialState = {
  categories: [],
  themeCategories: [],
  selectedUrlCategory: "",
  selectedTag: "",
  selectedThemeTag: "",
  selectedTagList: [],
  translations: {},
  loading: false,
  error: false,
  category: '',
  themeCategory: '',
  categoryList: [],
  page: 1,
  language: null,
  past: false,
  results: {
    total: 0,
    hits: [],
    hitCategories: {},
  },
};

const projectListingReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_PAST:
      return Object.assign({}, state, {
        past: action.past
      });
    case SET_CATEGORY:
      if (state.category !== action.category) {
        return Object.assign({}, state, {   
          category: action.category,
        });
      }
      return Object.assign({}, state, {   
        category: '',
      });
    case SET_THEME_CATEGORY:
      if (state.themeCategory !== action.category) {
        return Object.assign({}, state, {
          themeCategory: action.category,
        })
      }
      return Object.assign({}, state, {
        themeCategory: '',
      })
    case FIND_AND_SET_CATEGORY:
      if (state.categories.some(x => x.id === action.id)) {
        return Object.assign({}, state, {
          selectedUrlCategory: action.id,
          category: action.id,
          themeCategory: ''
        })
      } else if (state.themeCategories.some(x => x.id === action.id)) {
        return Object.assign({}, state, {
          selectedUrlCategory: action.id,
          category: '',
          themeCategory: action.id
        })
      } else {
        return Object.assign({}, state, {
          selectedUrlCategory: '',
          category: '',
          themeCategory: '',
        })
      }
    case ADD_CATEGORY_FILTER:
        return Object.assign({}, state, {
            categoryList: [...state.categoryList, action.category]
        });
    case REMOVE_CATEGORY_FILTER:
        return Object.assign({}, state, {
            categoryList: [...state.categoryList.filter((category) => category !== action.category)]
        });
    case REMOVE_MANY_FILTERS:
        return Object.assign({}, state, {
            categoryList: [...state.categoryList.filter((category) => state.categories.some((researchCategory) => category === researchCategory))]
        })    
    case PROJECT_SET_SELECTED_TAG:
      if (state.selectedTag !== action.id) {
        return Object.assign({}, state, {
          selectedTag: action.id
        });
      }
      // If user clicks the same tag, deselect it
      return Object.assign({}, state, {
        selectedTag: ''
      });
    case PROJECT_SET_SELECTED_THEME_TAG:
      if (state.selectedThemeTag !== action.id) {
        return Object.assign({}, state, {
          selectedThemeTag: action.id
        })
      }  
      // If user clicks the same tag, deselect it
      return Object.assign({}, state, {
        selectedThemeTag: ''
      });
    case PROJECT_FIND_AND_SET_SELECTED_TAG:
      if (state.categories.some(x => x.id === action.id)) {
        return Object.assign({}, state, {
          selectedTag: action.id,
          selectedThemeTag: '',
        })
      } else if (state.themeCategories.some(x => x.id === action.id)) {
        return Object.assign({}, state, {
          selectedTag: '',
          selectedThemeTag: action.id
        })
      } else {
        return Object.assign({}, state, {
          selectedTag: '',
          selectedThemeTag: '',
        })
      }
    case PROJECT_REMOVE_SELECTED_THEME_TAG:
        return Object.assign({}, state, {
            selectedTagList: [...state.selectedTagList.filter((selectedTag) => selectedTag !== action.id)]
        })
    case SET_PAGE:
      return Object.assign({}, state, {
        page: action.page,
      });
    case INIT_CATEGORIES:
      return Object.assign({}, state, {
        categories: action.categories,
      });
    // new
    case INIT_THEME_CATEGORIES:
    return Object.assign({}, state, {
        themeCategories: action.themeCategories,
    });
    case INIT_LANGUAGE:
      return Object.assign({}, state, {
        language: action.language,
      });
    case INIT_TRANSLATIONS:
      return Object.assign({}, state, {
        translations: action.translations,
      });
      case PROJECT_CLEAR_RESULTS:
      return Object.assign({}, state, {
          results: {
            hits: [],
            total: 0,
          }
      });
    case PERFORM_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: false,
      });
    case PERFORM_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        results: {
          hits: state.results.hits.concat(action.data.hits),
          total: action.data.total,
          hitCategories: action.data.hitCategories
        },
        loading: false,
        error: false,
      });
    case PERFORM_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: true,
      });
    default:
      return state;
  }
};

export default projectListingReducer;
